import { createRouter, createWebHistory } from "vue-router";
import { routes } from "@/router/routes";
import { useABVersionsStore } from "@/stores/abVersions";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    return { top: 0, behavior: "smooth" };
  },
});

const hasQueryParams = (route: any) => {
  return !!Object.keys(route.query).length;
};

router.beforeEach((to, from, next: any) => {
  useABVersionsStore(); // Initialize Store

  if (!hasQueryParams(to) && hasQueryParams(from)) {
    next({ name: to.name, query: from.query });
  } else {
    next();
  }
});

export default router;
